<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay" @click.self="handleClose">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ s__('Profile|Telegram account linking') }}</h3>
          <button type="button" class="modal-close" @click="handleClose" aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div class="modal-body">
          <div class="info-section">
            <h4>{{ s__('Profile|How it works') }}</h4>
            <p v-if="botUsername">
              {{
                sprintf(
                  s__(
                    'Profile|Press "Link Telegram account". We will open @%{botUsername} with a secure one-time linking token.'
                  ),
                  { botUsername }
                )
              }}
            </p>
            <p v-else>
              {{
                s__(
                  'Profile|Press "Link Telegram account". We will open the bot with a secure one-time linking token.'
                )
              }}
            </p>
            <p>
              {{
                s__(
                  'Profile|Then tap "Open Tracktor" in chat and confirm linking inside the Mini App.'
                )
              }}
            </p>

            <h4>{{ s__('Profile|Benefits') }}</h4>
            <p>
              {{
                s__(
                  'Profile|You will receive Telegram direct-message notifications and can use Telegram quick commands and reports.'
                )
              }}
            </p>
            <p>
              {{
                s__('Profile|Linking is safe: the token is single-use and expires automatically.')
              }}
            </p>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="handleClose">
            {{ s__('Profile|Close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { Teleport } from 'vue'
import { s__, sprintf } from '@/locale'
import CloseIcon from '../common/icons/CloseIcon.vue'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
  botUsername: {
    type: String,
    default: null,
  },
})

const emit = defineEmits(['close'])

useBodyScrollLock(computed(() => props.visible))

function handleClose() {
  emit('close')
}
</script>

<style scoped>
.info-section {
  line-height: 1.6;
}

.info-section h4 {
  margin: 20px 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-section h4:first-child {
  margin-top: 0;
}

.info-section p {
  margin: 0 0 16px 0;
  color: #666;
}
</style>
